<template>
  <div class="normal-toggle-chart">
    <basic-container>
      <Header title="支付通道占比" :hasPicker="true" ref="Header"  @refreshPayheader="getTablePayData" />

      <div class="header__date" flex="cross:center">
        <div
          v-for="(item,index) in tooggleDate"
          :key="index"
          class="header__date-row"
          flex="cross:center"
          :class="tooggleDateIndex === index?'header__date-row--active':''"
          @click="onHandleToggleDate(item,index)"
        >{{item}}</div>
      </div>

      <ve-pie :data="chartData" :settings="chartSettings" height="400px" legend-position="bottom"></ve-pie>

      <!-- <div>
        <div>
          <div>微信:0.99% | 3</div>
        </div>
      </div>-->
    </basic-container>
  </div>
</template>

<script>
import BasicContainer from '@vue-materials/basic-container'
import VePie from 'v-charts/lib/pie'
import Header from '../HeaderPay'
import util from '@/libs/util.js'
import * as agentService from '@/api/sys/agent'
export default {
  components: { BasicContainer, VePie, 'Header': Header },
  name: 'PayAccessChart',
  data () {
    this.chartSettings = {
      labelMap: {
        PV: 'test1',
        Order: 'test2'
      },
      // dimension: "type",
      // dataType: "percent",
      offsetY: 150,
      label: {
        show: true,
        position: 'outside',
        formatter: function (params) {
          return params.name.split('|')[0]
        }
      }
    }
    return {
      tooggleDateIndex: 0,
      tooggleDate: ['交易金额', '交易笔数'],

      chartData: {
        columns: ['type', 'percentage'],
        rows: [
        ]
      }
    }
  },
  mounted () {
    this.getTableDataPayjyje()
  },
  methods: {
    getTablePayData () {
      if (this.tooggleDateIndex == 0) {
        this.getTableDataPayjyje()
      } else if (this.tooggleDateIndex == 1) {
        this.getTableDataPayjybs()
      }
    },
    dateConversion (value) {
      var d = new Date(value)
      //  var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();
      var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()
      console.info('===========date=========' + date)
      return date
    },
    getTableDataPayjyje () {
      var formData4 = new FormData() // 声明一个FormData对象
      formData4.append('agentid', util.cookies.get('agentid'))
      formData4.append('type', '0')
      formData4.append('start_time', this.dateConversion(this.$refs.Header.pickerValue[0]))
      formData4.append('end_time', this.dateConversion(this.$refs.Header.pickerValue[1]))
      formData4.append('dl_type', util.cookies.get('dl_type'))
      formData4.append('xt_id', util.cookies.get('xt_id'))
      let countlistArray = []
      agentService.getStatisticsHomePay(formData4).then(data => {
        if (data != null && data != '') {
          // 循环遍历,将穿回来的list转换为chart需要的键值对形式

          let countlistmap = {}
          countlistmap['type'] = '微信: ' + data.wx_num_bf + '% | ' + data.wx_num_amount
          countlistmap['percentage'] = data.wx_num_amount
          countlistArray.push(countlistmap)

          let countlistmap2 = {}
          countlistmap2['type'] = '支付宝: ' + data.zfb_num_bf + '% | ' + data.zfb_num_amount
          countlistmap2['percentage'] = data.zfb_num_amount
          countlistArray.push(countlistmap2)

          let countlistmap3 = {}
          countlistmap3['type'] = '银行卡: ' + data.yhk_num_bf + '% | ' + data.yhk_num_amount
          countlistmap3['percentage'] = data.yhk_num_amount
          countlistArray.push(countlistmap3)

          let countlistmap4 = {}
          countlistmap4['type'] = '会员卡: ' + data.fyk_num_bf + '% | ' + data.fyk_num_amount
          countlistmap4['percentage'] = data.fyk_num_amount
          countlistArray.push(countlistmap4)

          let countlistmap5 = {}
          countlistmap5['type'] = '未知: ' + data.wz_num_bf + '% | ' + data.wz_num_amount
          countlistmap5['percentage'] = data.wz_num_amount
          countlistArray.push(countlistmap5)

          // 将键值对形式加到array数组里
          // 将行和列分别赋值给chartdata的行和列
          this.chartData.rows = countlistArray
        }
      })
    },
    getTableDataPayjybs () {
      var formData4 = new FormData() // 声明一个FormData对象
      formData4.append('agentid', util.cookies.get('agentid'))
      formData4.append('type', '1')
      formData4.append('start_time', this.dateConversion(this.$refs.Header.pickerValue[0]))
      formData4.append('end_time', this.dateConversion(this.$refs.Header.pickerValue[1]))
      formData4.append('dl_type', util.cookies.get('dl_type'))
      formData4.append('xt_id', util.cookies.get('xt_id'))
      // let countlistTitle=["日期", "我的佣金"];
      let countlistArray = []
      agentService.getStatisticsHomePay(formData4).then(data => {
        if (data != null && data != '') {
          // 循环遍历,将穿回来的list转换为chart需要的键值对形式
          let countlistmap = {}
          countlistmap['type'] = '微信: ' + data.wx_num_bf + '% | ' + data.wx_num
          countlistmap['percentage'] = data.wx_num
          countlistArray.push(countlistmap)

          let countlistmap2 = {}
          countlistmap2['type'] = '支付宝: ' + data.zfb_num_bf + '% | ' + data.zfb_num
          countlistmap2['percentage'] = data.zfb_num
          countlistArray.push(countlistmap2)

          let countlistmap3 = {}
          countlistmap3['type'] = '银行卡: ' + data.yhk_num_bf + '% | ' + data.yhk_num
          countlistmap3['percentage'] = data.yhk_num
          countlistArray.push(countlistmap3)

          let countlistmap4 = {}
          countlistmap4['type'] = '会员卡: ' + data.fyk_num_bf + '% | ' + data.fyk_num
          countlistmap4['percentage'] = data.fyk_num
          countlistArray.push(countlistmap4)

          let countlistmap5 = {}
          countlistmap5['type'] = '未知: ' + data.wz_num_bf + '% | ' + data.wz_num
          countlistmap5['percentage'] = data.wz_num
          countlistArray.push(countlistmap5)

          // 将键值对形式加到array数组里
          // 将行和列分别赋值给chartdata的行和列
          this.chartData.rows = countlistArray
        }
      })
    },
    onHandleToggleDate (item, index) {
      this.tooggleDateIndex = index
      if (index == 0) {
        this.getTableDataPayjyje()
      } else if (index == 1) {
        this.getTableDataPayjybs()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  &__date {
    display: inline-block;
    height: 30px;
    margin-top: 20px;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
  }
  &__date-row {
    padding: 0 0.2rem;
    height: 30px;
    float: left;
    font-size: 12px;
  }
  &__date-row--active {
    background-color: #409eff !important;
    color: #fff;
  }
  &__date-row:not(:last-child) {
    border-right: 1px solid #dcdfe6;
  }
}
</style>
